import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LinearProgress from 'material-ui/LinearProgress';
import get from 'lodash.get';
import muiThemeable from 'material-ui/styles/muiThemeable';
import compose from 'recompose/compose';
import { crudGetManyAccumulate as crudGetManyAccumulateAction } from "../admin-on-rest/src/actions/accumulateActions";
import restClient from "../restClient";

const linkToRecord = (basePath, id) => `${basePath}/${encodeURIComponent(id)}`;

const getStyles = muiTheme => ({
    link: {
        color: muiTheme.palette.accent1Color,
    },
});

export class ReferenceField extends Component {
    state = {
        refRecord: null,
        page: 1,
        perPage: 10,
        sort: {field: "name", order: "ASC"}
    };

    componentDidMount() {
        this.fetchReference(this.props);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.record.id !== nextProps.record.id) {
            this.fetchReference(nextProps);
        }
    }

    fetchReference(props) {
        const source = get(props.record, props.source);
        if (source !== null && typeof source !== 'undefined') {

            const {page, perPage, sort} = this.state;
            const {reference} = this.props;
            const pagination = {page: page, perPage: perPage};
            
            restClient("GET_MANY", reference, {
                pagination: {...pagination},
                sort: sort,
                ids: source
            }).then(({data}) => {
                if(data && data.length){
                    this.setState({refRecord: data[0]})
                }                
            });
        }
    }

    render() {
        const {
            record,
            source,
            reference,
            referenceRecord,
            basePath,
            allowEmpty,
            children,
            elStyle,
            linkType,
            muiTheme,
        } = this.props;
        
        const {
            refRecord
        } = this.state;
        
        if (React.Children.count(children) !== 1) {
            throw new Error('<ReferenceField> only accepts a single child');
        }
        if (!referenceRecord && !allowEmpty) {
            return <LinearProgress />;
        }
        const rootPath = basePath
            .split('/')
            .slice(0, -1)
            .join('/');
        const href = linkToRecord(
            `${rootPath}/${reference}`,
            get(record, source)
        );
        const linkStyle = { ...getStyles(muiTheme).link, ...elStyle };

        const child = React.cloneElement(children, {
            // record: referenceRecord,
            record: refRecord,
            resource: reference,
            allowEmpty,
            basePath,
            translateChoice: false,
        });

        if (linkType === 'edit' || linkType === true) {
            return (
                <Link style={linkStyle} to={href}>
                    {child}
                </Link>
            );
        }
        if (linkType === 'show') {
            return (
                <Link style={linkStyle} to={`${href}/show`}>
                    {child}
                </Link>
            );
        }
        return child;
    }
}

ReferenceField.propTypes = {
    addLabel: PropTypes.bool,
    allowEmpty: PropTypes.bool.isRequired,
    basePath: PropTypes.string.isRequired,
    children: PropTypes.element.isRequired,
    crudGetManyAccumulate: PropTypes.func.isRequired,
    elStyle: PropTypes.object,
    label: PropTypes.string,
    record: PropTypes.object,
    reference: PropTypes.string.isRequired,
    referenceRecord: PropTypes.object,
    source: PropTypes.string.isRequired,
    linkType: PropTypes.oneOfType([PropTypes.string, PropTypes.bool])
        .isRequired,
};

ReferenceField.defaultProps = {
    referenceRecord: null,
    record: {},
    allowEmpty: false,
    linkType: 'edit',
};

function mapStateToProps(state, props) {
    return {
        referenceRecord: state.admin.resources[props.reference] ?
            state.admin.resources[props.reference].data[
                get(props.record, props.source)
            ] : null
    };
}

const ConnectedReferenceField = compose(
    connect(mapStateToProps, {
        crudGetManyAccumulate: crudGetManyAccumulateAction,
    }),
    muiThemeable()
)(ReferenceField);

ConnectedReferenceField.defaultProps = {
    addLabel: true,
};

export default ConnectedReferenceField;



// WEBPACK FOOTER //
// ./src/components/ReferenceField.js